import { Tabs } from "antd";
import PropTypes from "prop-types";

const Simple = ({ ...props }) => {
  return (
    <div className="custom--tab">
      <Tabs {...props} />
    </div>
  );
};

Simple.propTypes = {
  // Ant Design Tabs props
};

export default Simple;
